import _ from "lodash";
import { Version } from "./Version";

export const LayoutZoom = {

	Name: "Layout Zoom",

	Libraries: [],

	Events: {

		"Selected Version Switched,Selected Creative Fully Loaded,Preview Size Changed,Preview Device Changed,Preview Orientation Changed": function() {

			this.restorePreviewZoomAndOffset();

		}

	},

	Actions: {},

	init() {

		this.previewZoom = 1;
		this.previewOffset = { x: 0, y: 0 };
		this.previewZoomDefault = 1;
		this.previewOffsetDefault = { x: 0, y: 0 };
		this.previewDragProcess = null;

		this.restorePreviewZoomAndOffset();

	},

	getPreviewZoomOffsetStorageKey() {

		if (!Version.SelectedVersion?.id) return null;

		let versionId = Version.SelectedVersion.id;
		let sizeKey = this.getPreviewSizeKey();
		let key = `layout-preview-zoom-offset:${versionId}:${sizeKey}`;

		//У плейаблов нет sizes, поэтому дополнительно привязываем ключ к device и orientation
		if (Creative.SelectedCreative?.type === 'playable') {

			let device = this.previewDevice;
			let orientation = this.previewOrientation[device];

			key += `:${device}:${orientation}`;

		}

		return key;

	},

	restorePreviewZoomAndOffset() {

		let storageKey = this.getPreviewZoomOffsetStorageKey();

		if (storageKey) {

			let savedData = window.localStorage.getItem(storageKey);

			if (savedData) {

				try {

					let parsed = JSON.parse(savedData);
					this.previewZoom = (typeof parsed.zoom === 'number' && !isNaN(parsed.zoom)) ? parsed.zoom : this.previewZoomDefault;
					this.previewOffset = (parsed.offset && typeof parsed.offset.x === 'number' && typeof parsed.offset.y === 'number') ? parsed.offset : { ...this.previewOffsetDefault };

				} catch(e) {

					this.previewZoom = this.previewZoomDefault;
					this.previewOffset = { ...this.previewOffsetDefault };

				}

			} else {

				this.previewZoom = this.previewZoomDefault;
				this.previewOffset = { ...this.previewOffsetDefault };

			}

		} else {

			this.previewZoom = this.previewZoomDefault;
			this.previewOffset = { ...this.previewOffsetDefault };

		}

		Broadcast.call("Preview Zoom Changed", [this.previewZoom, this.previewOffset]);

	},

	savePreviewZoomAndOffset() {

		let storageKey = this.getPreviewZoomOffsetStorageKey();

		if (!storageKey) return;

		let data = {
			zoom: this.previewZoom,
			offset: this.previewOffset
		};

		window.localStorage.setItem(storageKey, JSON.stringify(data));

	},

	setPreviewZoom(zoom, save = true) {

		zoom = parseFloat(zoom);
		if (isNaN(zoom)) zoom = this.previewZoomDefault;

		zoom = Math.max(0.1, Math.min(5, Math.round(zoom * 100) / 100));

		this.previewZoom = zoom;

		if (save) this.savePreviewZoomAndOffset();

		Broadcast.call("Preview Zoom Changed", [this.previewZoom, this.previewOffset]);

	},

	processPreviewZoomWheel(e) {

		let delta = 0;

		if (e.wheelDelta !== undefined) {

			delta = e.wheelDelta > 0 ? 0.05 : -0.05;

		} else if (e.deltaY !== undefined) {

			delta = e.deltaY < 0 ? 0.05 : -0.05;

		}

		if (e.shiftKey) delta *= 2;

		let currentZoom = this.previewZoom || 1;
		let newZoom = Math.round((currentZoom + delta) * 100) / 100;
		newZoom = Math.max(0.1, Math.min(5, newZoom));

		this.setPreviewZoom(newZoom);

	},

	setPreviewOffset(offset, save = true) {

		if (!offset) offset = { ...this.previewOffsetDefault };

		this.previewOffset = {
			x: Math.round(offset.x || 0),
			y: Math.round(offset.y || 0)
		};

		if (save) this.savePreviewZoomAndOffset();

		Broadcast.call("Preview Zoom Changed", [this.previewZoom, this.previewOffset]);

	},

	resetPreviewZoomAndOffset() {

		this.previewZoom = this.previewZoomDefault;
		this.previewOffset = { ...this.previewOffsetDefault };

		this.savePreviewZoomAndOffset();

		Broadcast.call("Preview Zoom Changed", [this.previewZoom, this.previewOffset]);

	},

	isPreviewZoomOrOffsetModified() {

		let isZoomModified = (typeof this.previewZoom === 'number' && this.previewZoom !== this.previewZoomDefault);
		let isOffsetModified = Boolean(this.previewOffset && (this.previewOffset.x !== this.previewOffsetDefault.x || this.previewOffset.y !== this.previewOffsetDefault.y));

		return isZoomModified || isOffsetModified;

	},

	startPreviewDrag(e, options = { threshold: 20 }) {

		if (e.button !== 0) return;

		this.previewDragProcess = {
			startX: e.clientX,
			startY: e.clientY,
			startOffsetX: this.previewOffset?.x || 0,
			startOffsetY: this.previewOffset?.y || 0,
			threshold: options.threshold !== undefined ? options.threshold : 20,
			thresholdPassed: (options.threshold || 0) === 0,
			moved: false
		};

		if (this._onPreviewMouseMove) {

			window.removeEventListener('mousemove', this._onPreviewMouseMove);
			window.removeEventListener('mouseup', this._onPreviewMouseUp);

		}

		this._onPreviewMouseMove = (event) => this.processPreviewDrag(event);
		this._onPreviewMouseUp = (event) => this.stopPreviewDrag(event);

		window.addEventListener('mousemove', this._onPreviewMouseMove);
		window.addEventListener('mouseup', this._onPreviewMouseUp);

		if (this.previewDragProcess.thresholdPassed) {

			Broadcast.call("Preview Drag State Changed", [true]);

		}

	},

	processPreviewDrag(e) {

		if (!this.previewDragProcess) return;

		let dx = e.clientX - this.previewDragProcess.startX;
		let dy = e.clientY - this.previewDragProcess.startY;
		let distance = Math.hypot(dx, dy);

		if (!this.previewDragProcess.thresholdPassed) {

			if (distance >= this.previewDragProcess.threshold) {

				this.previewDragProcess.thresholdPassed = true;
				Broadcast.call("Preview Drag State Changed", [true]);

			}

		}

		if (this.previewDragProcess.thresholdPassed) {

			this.previewDragProcess.moved = true;

			let newOffsetX = this.previewDragProcess.startOffsetX + dx;
			let newOffsetY = this.previewDragProcess.startOffsetY + dy;

			this.setPreviewOffset({ x: newOffsetX, y: newOffsetY }, false);

		}

	},

	stopPreviewDrag(e) {

		if (!this.previewDragProcess) return;

		if (this._onPreviewMouseMove) {

			window.removeEventListener('mousemove', this._onPreviewMouseMove);
			window.removeEventListener('mouseup', this._onPreviewMouseUp);
			this._onPreviewMouseMove = null;
			this._onPreviewMouseUp = null;

		}

		if (this.previewDragProcess.thresholdPassed) {

			this.savePreviewZoomAndOffset();
			Broadcast.call("Preview Drag State Changed", [false]);

		}

		this.previewDragProcess = null;

	}

};
